import { render, staticRenderFns } from "./readjustment.vue?vue&type=template&id=0845e99f&"
import script from "./readjustment.vue?vue&type=script&lang=js&"
export * from "./readjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports